import CreateAccount from '@/pages/Onboarding/components/CreateAccount';
import { capture } from '@/handlers/error';
import { useAuth } from '@/providers/auth/AuthProvider';
import { useSession } from '@/providers/session/SessionProvider';
import { useNotifications } from '@toolpad/core';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { FullScreenLoading } from '@/components/displays/FullScreenLoading';

export const OnboardingPage: React.FC = () => {
    const { createAccount } = useAuth();
    const { setSession } = useSession();
    const navigate = useNavigate();
    const notifications = useNotifications();
    const [email, setEmail] = useState('');

    // params
    const url = useMemo(() => new URL(window.location.href), []);
    const params = useMemo(() => url.searchParams, [url.searchParams]);
    const token = useMemo(() => params.get('token'), [params]);

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode<JwtPayload & { email?: string }>(token);
                if (decoded.email) {
                    setEmail(decoded.email);
                } else {
                    throw new Error('Invalid token');
                }
            } catch (error) {
                capture(error);
                notifications.show(error instanceof Error ? error.message : `${error}`, { severity: 'error', autoHideDuration: 5000 });
            }
        }
    }, [notifications, token]);

    return email && token ? (
        <CreateAccount
            onSignIn={() => navigate('/welcome')}
            email={email}
            createAccount={async (name, password) => {
                await createAccount(token, password, name)
                    .then(async (session) => {
                        await setSession(session.token);
                        navigate('/lessons', { replace: true });
                    })
                    .catch((error) => {
                        capture(error);
                        notifications.show(error instanceof Error ? error.message : `${error}`, { severity: 'error', autoHideDuration: 5000 });
                    });
            }}
        />
    ) : (
        <FullScreenLoading />
    );
};

export default OnboardingPage;
